import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import BeachAccessOutlinedIcon from '@mui/icons-material/BeachAccessOutlined';
import Groups2OutlinedIcon from '@mui/icons-material/Groups2Outlined';
import PaidOutlinedIcon from '@mui/icons-material/PaidOutlined';
import React from 'react';
import { IDashboardData } from '../interfaces/user/IUser';
import { lightPalette } from '../mui/palettes';
import HouseboatOutlinedIcon from '@mui/icons-material/HouseboatOutlined';
export const getDashboardIcon = (dashKey: keyof IDashboardData) => {
  if (dashKey === 'employees') {
    return <Groups2OutlinedIcon fill={lightPalette.primary.main} />;
  }
  if (dashKey === 'currentBalance') {
    return <PaidOutlinedIcon fill={lightPalette.primary.main} />;
  }
  if (dashKey === 'approvedVacations') {
    return <BeachAccessOutlinedIcon fill={lightPalette.primary.main} />;
  }
  if (dashKey === 'departments') {
    return <BadgeOutlinedIcon fill={lightPalette.primary.main} />;
  }
  if (
    [
      'leftSickDays',
      'leftBusinessTravelLeaveDays',
      'leftCarryOverVacationDays',
      'leftVacationDays',
    ]?.includes(dashKey)
  ) {
    return <HouseboatOutlinedIcon fill={lightPalette.primary.main} />;
  }
  return <AccountTreeOutlinedIcon fill={lightPalette.primary.main} />;
};
